import React from 'react';
import PropTypes from 'prop-types';
import deepmerge from 'deepmerge';

import IntegrationAvatarAndName from 'app/shared/components/integrations/IntegrationAvatarAndName';

import buildBubbleClickProps from 'app/components/data-table/buildBubbleClickProps';

export default function IntegrationAvatarCell({
  starterkitId,
  name,
  bubbleClickEvent,
  AvatarProps = {},
  TypographyProps = {},
}) {
  const stackProps = {
    overflow: 'hidden',
    title: name,
  };
  const bubbleClickProps = buildBubbleClickProps(bubbleClickEvent);

  const finalStackProps = deepmerge(stackProps, bubbleClickProps);
  const finalAvatarProps = deepmerge({ imgProps: bubbleClickProps }, AvatarProps);
  const finalTypographyProps = deepmerge(bubbleClickProps, TypographyProps);

  return (
    <IntegrationAvatarAndName
      integration={{ starterkitId, name }}
      AvatarProps={finalAvatarProps}
      TypographyProps={finalTypographyProps}
      StackProps={finalStackProps}
    />
  );
}

IntegrationAvatarCell.propTypes = {
  starterkitId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  bubbleClickEvent: PropTypes.bool,
  AvatarProps: PropTypes.object,
  TypographyProps: PropTypes.object,
};
